import { getErrorMessage } from '@eigtech/function-utils/errors'
import { sentenceCase } from '@eigtech/function-utils/strings'
import { useEffect, useState } from 'react'
import { EigApiError } from '../EigApiError'

export function useGetErrorResponse(error: unknown) {
  const [errorResponse, _setErrorResponse] = useState<string | undefined>(undefined)

  useEffect(() => {
    function setErrorResponse(message: string) {
      _setErrorResponse(sentenceCase(message))
    }

    async function getErrorResponse() {
      if (!error) {
        _setErrorResponse(undefined)
        return
      }

      if (error instanceof EigApiError) {
        const data = await (error as EigApiError<{ message?: string } | string | undefined>).data

        setErrorResponse(typeof data === 'string' ? data : (data?.message ?? 'Unknown error'))
        return
      }

      setErrorResponse(getErrorMessage(error))
    }

    getErrorResponse()
  }, [error])

  return errorResponse
}
